module.exports = __webpack_public_path__ + "static/media/LogoDE.99c9bf17.svg";